import { render } from "./DetailSupplierCard.vue?vue&type=template&id=473acc1e&scoped=true"
import script from "./DetailSupplierCard.vue?vue&type=script&lang=js"
export * from "./DetailSupplierCard.vue?vue&type=script&lang=js"

import "./DetailSupplierCard.vue?vue&type=style&index=0&id=473acc1e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-473acc1e"]])

export default __exports__